import LinearProgress from '@material-ui/core/LinearProgress';

export default function Loading() {
	return (
		<div className="mt-10 mx-10">
			<LinearProgress />
		</div>
	)
}